import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-price-display',
  template: `
    <ng-container *ngIf="sale">
      <span class="text-primary font-semibold"
            [ngClass]="getProfitClass()">{{sale | number}}</span>
      <span class="text-gray-500 text-sm">({{base | number}})</span>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceDisplayComponent implements OnChanges {
  @Input() sale!: number;
  @Input() base!: number;
  @Input() feePercent = 3;

  netProfit = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.sale && this.base){
      const fee = (this.sale * this.feePercent) / 100;
      this.netProfit = this.sale - fee - this.base;
    }
  }

  getProfitClass(): string {
    const net = this.netProfit;
    if (net < 0) { return 'text-red-600'; }
    if (net < 50) { return 'text-gray-500'; }
    if (net < 200) { return 'text-green-400'; }
    if (net < 500) { return 'text-green-600'; }
    return 'text-green-800';
  }
}
